import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  BsLinkedin,
  BsInstagram,
  BsFacebook,
  BsEnvelope,
  BsPinterest,
} from "react-icons/bs";
import { TbMapPin } from "react-icons/tb";
import logo from "../../assets/logo.png";
import "./footer.css";

const services = [
  "Website Design & Development",
  "Social Media Marketing",
  "Performance Marketing",
  "LinkedIn Personal Branding",
  "Graphic Designing & Video Editing",
  "Search Engine Optimization (SEO)",
  "Content Writing",
  "Product Photography",
];

const company = [
  { label: "Home",       path: "/" },
  { label: "About Us",   path: "/about" },
  { label: "Projects",   path: "/projects" },
  { label: "Services",   path: "/services" },
  { label: "Contact",    path: "/contact" },
];

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        {/* Main grid */}
        <Row className="gy-5 footer-top">
          {/* Brand col */}
          <Col xs={12} md={6} lg={3}>
            <div className="footer-brand">
              <img src={logo} alt="Logo" height="38" className="footer-logo" />
            </div>
            <p className="footer-desc">
              From strategy to execution, our digital marketing solutions are
              designed to attract the right audience, convert them into
              customers, and scale your business.
            </p>
            <div className="footer-socials">
              <a
                href="https://www.linkedin.com/company/jsrdigimarketing/"
                aria-label="LinkedIn"
              >
                <BsLinkedin />
              </a>
              <a
                href="https://www.instagram.com/jsrdigimarketing/"
                aria-label="Instagram"
              >
                <BsInstagram />
              </a>
              <a
                href="https://www.facebook.com/jsrdigimarketing/"
                aria-label="Facebook"
              >
                <BsFacebook />
              </a>
              <a
                href="https://in.pinterest.com/jsrdigimarketing/"
                aria-label="Facebook"
              >
                <BsPinterest />
              </a>
            </div>
          </Col>

          {/* Services col */}
          <Col xs={6} md={4} lg={3} className="offset-lg-1">
            <h6 className="footer-col-title">SERVICES</h6>
            <ul className="footer-links">
              {services.map((s) => (
                <li key={s}>
                  <a href="#services">{s}</a>
                </li>
              ))}
            </ul>
          </Col>

          {/* Company col */}
          <Col xs={6} md={3} lg={2}>
            <h6 className="footer-col-title">COMPANY</h6>
            <ul className="footer-links">
              {company.map((c) => (
                <li key={c.label}>
                  <Link to={c.path}>{c.label}</Link>
                </li>
              ))}
            </ul>
          </Col>

          {/* Contact col */}
          <Col xs={12} md={6} lg={3} className="offset-md-0">
            <h6 className="footer-col-title">CONTACT</h6>

            <a
              href="https://www.google.com/maps/search/?api=1&query=Royapettah,Chennai,Tamil+Nadu,India+600014"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <div className="footer-contact-item">
                <TbMapPin className="contact-icon" />
                <div>
                  <p className="contact-office">Our Office</p>
                  <p className="contact-detail">
                    Royapettah, Chennai, Tamil Nadu, <br/> India - 600 014
                  </p>
                  <p className="contact-detail">+91 97915 09915</p>
                </div>
              </div>
            </a>

            <div className="footer-contact-item">
              <BsEnvelope className="contact-icon" />
              <p className="contact-detail">jsrdigimarketing@gmail.com</p>
            </div>

            <Button
              className="footer-cta"
              href="https://wa.me/917550366612"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get Free Consultation →
            </Button>
          </Col>
        </Row>

        {/* Bottom bar */}
        <Row className="footer-bottom align-items-center justify-content-center">
          <Col xs={12} md={12} className="text-center">
            <p className="footer-copy">
              © 2026 - JSR DigiMarketing 
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
